import { types, applySnapshot} from "mobx-state-tree";
import { Framework } from "@flint/framework";

const CSVUploadModel = types
  .model("CSVUploadModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch(term) {
      Framework.sendEvent("UPLOAD_CSV", { term });
    },
    set(response) {
      let data=response.data.response;
      let resp=`CSV Mapping for <b>${data.isbn}</b> `;
      if(data.isbn===null){
        resp="Seems like you've uploaded a wrong excel file. Please check again."
      }
      else if(data.status==="SUCCESS"){
        resp+="completed successfully.";
        for(let i in data){
          if(typeof(data[i])==="string" && i!=="isbn" && i!=="status"){
            if(data[i].length>0) resp+=`<br/><br/><b>${i}</b>: ${data[i]}`;
          }
          else if(typeof(data[i])==="object"){
              if(data[i].length>0) resp+=`<br/><br/><b>${i}</b>: ${data[i].join(", ")}`;
            }
          }
      }
      else if(data.status==="NOTEXIST"){
        resp+="couldn't be as ePub doesn't exist.";
      }
      else{
        resp+="Failed."
      }
      applySnapshot(self, {
        res:resp,
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default CSVUploadModel;
